import React from 'react';
import { cleanProductDescription } from '../../utils/format.utils';
import { useCart } from '../../context/CartContext';
import { toast } from 'react-toastify';

const ProductDetails = ({ product }) => {
    const { addToCart } = useCart();
    const description = cleanProductDescription(product.description);
    const shortDescription = cleanProductDescription(product.shortDescription);

    const handleAddToCart = () => {
        addToCart(product);
    };

    return (
        <div className="flex flex-col md:flex-row gap-6 p-6 max-w-4xl mx-auto">
            <div className="md:w-2/5">
                <div className="relative">
                    <img
                        src={product.imageUrl || '/assets/images/default-product-image.svg'}
                        alt={product.name}
                        className="w-full h-64 object-cover rounded-xl shadow-lg"
                    />
                    {product.salePrice && (
                        <div className="absolute top-4 right-4 bg-red-500 text-white px-3 py-1 rounded-full text-sm">
                            Promo
                        </div>
                    )}
                </div>
            </div>
            
            <div className="md:w-3/5 space-y-4">
                <div className="space-y-2">
                    <h2 className="text-2xl font-bold text-gray-800 leading-tight">{product.name}</h2>
                    <div className="flex items-baseline gap-4">
                        {product.salePrice ? (
                            <>
                                <span className="text-2xl font-bold text-primary">{product.salePrice} €</span>
                                <span className="text-lg text-gray-500 line-through">{product.regularPrice} €</span>
                            </>
                        ) : (
                            <span className="text-2xl font-bold text-primary">{product.price} €</span>
                        )}
                    </div>
                </div>
                
                {!description && shortDescription && shortDescription.length > 0 && (
                    <div className="prose prose-sm max-w-none text-gray-600 mt-4">
                        <div dangerouslySetInnerHTML={{ __html: shortDescription }} />
                    </div>
                )}

                {description && description.length > 0 && (
                    <div className="prose prose-sm max-w-none border-t border-gray-100 pt-4">
                        <h3 className="text-lg font-medium text-gray-800">Description</h3>
                        <div className="text-gray-600" dangerouslySetInnerHTML={{ __html: description }} />
                    </div>
                )}

                {product.wooProductId && (
                    <div className="text-sm text-gray-500">
                        Référence: {product.wooProductId}
                    </div>
                )}

                <div className="pt-4">
                    <button 
                        onClick={handleAddToCart}
                        className="btn btn-primary w-full"
                    >
                        Ajouter au panier
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductDetails;
